import React, {useState}  from 'react';
import { useSelector } from 'react-redux';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import BasicTable from '@cybs-ui/components/lib/table';
import { isDefaultSite } from '../../../commons/ui-commons.js';
import { getPartnerFullName} from '../../../lhs/reducers/configuration-reducer.js';

const HeaderCard = () => {

    const [tabledata, setTableData] = useState([]);

    var currentAuthType = useSelector(state => state.configurationReducer.currentAuthType);
    var title = (currentAuthType === 'HTTP Signature')?"HTTP Headers":"JWT Headers";

    var apiHostURL = useSelector(state => state.configurationReducer.apiHostURL);
    var apiProdURL = useSelector(state => state.configurationReducer.apiProdURL);

    var partnerFullName = getPartnerFullName();
    if(isDefaultSite()){
        partnerFullName = partnerFullName.trim().length > 0 ? partnerFullName : 'Cybersource';
    }

    var http_rows = [
        {   
            id: 'http',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'v-c-merchant-id'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: `Your ${partnerFullName} organization ID.`
                }
            ]
        },
        {   
            id: 'http',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Date'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: 'The date in RFC1123 format: Thu, 18 Jul 2019 00:18:03 GMT'
                }
            ]
        },
        {   
            id: 'http',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Content-Type'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: 'application/json'
                }
            ]
        },
        {   
            id: 'http',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Host'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: `The endpoint for the transaction. Valid values: \n`+apiHostURL+`\n`+apiProdURL+``
                }
            ]
        }
    ]
    
    var jwt_rows = [
        {   
            id: 'jwt',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Bearer Token'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: 'JWT Token Generated.'
                }
            ]
        },
        {   
            id: 'jwt',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Content-Type'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: 'application/json'
                }
            ]
        },
        {   
            id: 'jwt',
            fields: [
                {
                    staticField: 'Field',
                    type: 'staticField',
                    value: 'Host'
                },
                {
                    staticField: 'Type',
                    type: 'staticField',
                    value: 'Required'
                },
                {
                    staticField: 'Description',
                    type: 'staticField',
                    value: `The endpoint for the transaction. Valid values: \n`+apiHostURL+`\n`+apiProdURL+``
                }
            ]
        }
    ]
    const headers = [
        {
            cell: {
                type: "staticText"
            },
            id: "http",
            label: "Field",
            width: 500,
        },
        {
            cell: {
            type: "staticText"
            },
            id: "http",
            label: "Type",
            width: 500,
        },
        {
            cell: {
            type: "staticText"
            },
            id: "http",
            label: "Description",
            width: 500,
        }
    ]

    React.useEffect(function switchState() {
        if(currentAuthType === 'HTTP Signature') {
            setTableData(http_rows);
            title = "HTTP Headers";
        }
        else {
            setTableData(jwt_rows);
            title = "JWT Headers"
        }
    }, [currentAuthType]);
    
    if(apiHostURL && apiProdURL){
        return (
            <div style={{marginLeft: '4px'}}> 
                <CybsCard dataTest={'basicTableWrapper'} isBodyPadded
                      header={
                        <CybsActionBar 
                        i18n={{ title: title}}
                        dataTest="payment-info-with-button"
                        />
                      }
                >
                    <p>The following headers are required for every API request, which uses the {currentAuthType} authentication method.</p>
                    <BasicTable 
                        headers = {headers}
                        rows = {tabledata}
                    />
                </CybsCard>
               </div>
        );
    }
    else{
        return(
            <div></div>
        );

    }
};

HeaderCard.displayName = 'HeaderCard';
export default HeaderCard;

       